import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { CurrencyDetails, Piwik } from '../../types';

import './CurrencySelector.scss';

interface CurrencySelectorClickerProps {
    selectedCurrency: CurrencyDetails | undefined;
    onClick: () => void;
    piwik: Piwik | undefined;
}

const CurrencySelectorClicker = ({ selectedCurrency, onClick, piwik }: CurrencySelectorClickerProps) => (
    <button
        className="currency-selector-clicker"
        data-track-id={piwik?.visaCalculator?.visaExchangeCalculatorSelectCurrency?.dataTrackId}
        data-track-linkname={piwik?.visaCalculator?.visaExchangeCalculatorSelectCurrency?.dataTrackLinkname}
        id={piwik?.visaCalculator?.visaExchangeCalculatorSelectCurrency?.dataTrackId}
        onClick={() => onClick()}
        type="button"
    >
        <span className="currency-code">{selectedCurrency?.currencyCode}</span>
        <span>
            <Icon type={IconTypes.LITEN_PIL_NED} />
        </span>
    </button>
);

export default CurrencySelectorClicker;
